<template>
  <!-- A month grid with one session landing in a dated cell, plus a chip.
       The outcome, not a logo. Capped at 96px so the headline stays above
       the fold on a laptop. -->
  <svg
    width="200"
    height="96"
    viewBox="0 0 200 96"
    fill="none"
    aria-hidden="true"
    focusable="false"
  >
    <rect
      x="28"
      y="6"
      width="144"
      height="84"
      rx="8"
      fill="#fff"
      stroke="#e4e4e7"
    />
    <rect x="28" y="6" width="144" height="18" rx="8" fill="#f4f4f5" />
    <rect x="28" y="16" width="144" height="8" fill="#f4f4f5" />
    <g fill="#d4d4d8">
      <rect x="40" y="12" width="14" height="4" rx="2" />
      <rect x="60" y="12" width="14" height="4" rx="2" />
      <rect x="80" y="12" width="14" height="4" rx="2" />
      <rect x="100" y="12" width="14" height="4" rx="2" />
      <rect x="120" y="12" width="14" height="4" rx="2" />
      <rect x="140" y="12" width="14" height="4" rx="2" />
    </g>
    <g stroke="#f4f4f5">
      <path d="M28 46h144M28 68h144" />
      <path d="M57 24v66M86 24v66M115 24v66M144 24v66" />
    </g>
    <g fill="#e4e4e7">
      <circle cx="42" cy="34" r="2.5" />
      <circle cx="71" cy="34" r="2.5" />
      <circle cx="100" cy="34" r="2.5" />
      <circle cx="129" cy="34" r="2.5" />
      <circle cx="158" cy="34" r="2.5" />
      <circle cx="42" cy="56" r="2.5" />
      <circle cx="71" cy="56" r="2.5" />
      <circle cx="129" cy="56" r="2.5" />
      <circle cx="158" cy="56" r="2.5" />
      <circle cx="42" cy="78" r="2.5" />
      <circle cx="71" cy="78" r="2.5" />
      <circle cx="100" cy="78" r="2.5" />
    </g>
    <rect
      x="90"
      y="50"
      width="22"
      height="14"
      rx="3"
      fill="#ede9fe"
      stroke="#c4b5fd"
    />
    <rect x="94" y="55" width="14" height="2" rx="1" fill="#6d28d9" />
    <rect x="94" y="59" width="9" height="2" rx="1" fill="#a78bfa" />
    <g>
      <rect x="104" y="40" width="44" height="14" rx="7" fill="#18181b" />
      <circle cx="113" cy="47" r="3" fill="#22c55e" />
      <rect x="120" y="45.5" width="22" height="3" rx="1.5" fill="#fff" />
    </g>
  </svg>
</template>
